module.exports = __webpack_public_path__ + "static/img/lifestyle_23.e234e2fe.jpg";